import 'angular-cookies';
// The below is a work around to the angular data grid not having full support of webpack style loading
require( '../node_modules/angular-data-grid/dist/dataGrid');
require( '../node_modules/angular-data-grid/dist/pagination');



// WEBPACK FOOTER //
// ./src/vendor.ts